<template>
  <div class="bin-clocks">
    <div class="bin-toolbar">
      <h3 v-if="binLabel" style="font-weight: bold;">
        {{ binLabel }}
      </h3>
      <Checkbox v-model="co2Enabled" binary>
        CO2 enabled
      </Checkbox>
      <Checkbox v-model="dryingEnabled" binary>
        Drying enabled
      </Checkbox>
      <Checkbox v-model="reconditioning" binary>
        Reconditioning enabled
      </Checkbox>
      <Checkbox v-for="heatingUnit in bin.heatingUnits.children"
        :modelValue="heatingUnit.clockEnabled.value"
        @update:modelValue="value => toggleHeatingUnit(heatingUnit, value)"
      >
        {{ heatingUnit.name.value }} clock enabled
      </Checkbox>
    </div>
    <ClockBar
      :name="'Modes'"
      :options="modeOptions"
      :committed="committed"
      :clock="bin.modeSchedule"
      :fillSize="fillSize"
      :popoverFillSize="15"
      :selectedOption="getSelectedOption(modeOptions)"
      :onChange="onChange">
    </ClockBar>
    <ClockBar v-if="bin.co2Enabled.value"
      :name="'Purges'"
      :options="filteredPurgeOptions"
      :committed="committed"
      :clock="bin.purgeSchedule" 
      :fillSize="fillSize"
      :popoverFillSize="1"
      :selectedOption="getSelectedOption(purgeOptions)"
      :onChange="onChange">
    </ClockBar>
    <template v-for="heatingUnit in bin.heatingUnits.children">
      <ClockBar v-if="heatingUnit.clockEnabled.value"
        :name="heatingUnit.name.value"
        :options="onOffOptions"
        :committed="committed"
        :clock="heatingUnit.clock" 
        :fillSize="fillSize"
        :popoverFillSize="15"
        :selectedOption="getSelectedOption(onOffOptions)"
        :onChange="onChange"
      ></ClockBar>
    </template>
    <ClockBar v-if="bin.dryingEnabled.value"
      :name="'Drying'"
      :options="onOffOptions"
      :committed="committed"
      :clock="bin.dryingSchedule" 
      :fillSize="fillSize"
      :popoverFillSize="15"
      :selectedOption="getSelectedOption(onOffOptions)"
      :onChange="onChange">
    </ClockBar>
    <template v-for="humidifier in bin.humidifiers.children">
      <ClockBar v-if="usingTimedOutput(humidifier)" 
        :key="humidifier.handle"  
        :name="humidifier.name.value"
        :options="onOffOptions"
        :committed="committed"
        :clock="humidifier.timedOutputSchedule" 
        :fillSize="fillSize"
        :popoverFillSize="15"
        :selectedOption="getSelectedOption(onOffOptions)"
        :onChange="onChange">
      </ClockBar>
    </template>
    <ClockBar v-for="timedOutput in bin.timedOutputs.children" 
      :key="timedOutput.handle"
      :name="timedOutput.name.value"
      :options="onOffOptions"
      :committed="committed"
      :clock="timedOutput.schedule" 
      :fillSize="fillSize"
      :popoverFillSize="1"
      :selectedOption="getSelectedOption(onOffOptions)"
      :onChange="onChange">
    </ClockBar>
  </div>  
</template>

<script>
import store from "./store.js";
import ClockBar from "./ClockBar.vue";
import Checkbox from "./Checkbox.vue";
import { isAssigned } from "./appUtility.js";

export default {
  components: { ClockBar, Checkbox },
  props: [
    "bin",
    "modeOptions",
    "purgeOptions",
    "onOffOptions",
    "selectedOption",
    "fillSize",
    "committed",
    "onChange"
  ],
  computed: {
    binLabel() {
      let session = this.bin.$session;
      let numBinsInSystem = session.system.bins.children.length;
      if (store.sessions.length == 1)
        if (numBinsInSystem == 1)
          return "";
        else
          return this.bin.name.value
      if (numBinsInSystem == 1)
        return session.system.boardName.value;
      else
        return `${session.system.boardName.value} / ${this.bin.name.value}`;
    },
    co2Enabled: {
      get() { return this.bin.co2Enabled.value; },
      set(value) { this.bin.co2Enabled.value = value; this.onChange(); }
    },
    dryingEnabled: {
      get() { return this.bin.dryingEnabled.value; },
      set(value) { this.bin.dryingEnabled.value = value; this.onChange(); }
    },
    reconditioning: {
      get() { return this.bin.reconditioning.value; },
      set(value) { this.bin.reconditioning.value = value; this.onChange(); }
    },
    filteredPurgeOptions() {
      return this.purgeOptions.filter(option => 
        option.binCondition == null ||
        option.binCondition(this.bin)
      );
    }
  },
  methods: {
    toggleHeatingUnit(heatingUnit, value) {
      heatingUnit.clockEnabled.value = value;
      this.onChange();
    },
    usingTimedOutput(humidifier) {
      return humidifier.userMode.value == "byTimeClock";
    },
    getSelectedOption(options) {
      if (options.includes(this.selectedOption))
        return this.selectedOption;
      else
        return null;
    }
  }
}
</script>

<style scoped>
.bin-clocks {
  display: flex;
  flex-direction: column;
  gap: 15px;
}
label {
  cursor: pointer;
}
.bin-toolbar {
  display: flex;
  align-items: center;
  gap: 0.2in;
}
</style>